import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { Observable, tap } from "rxjs";

@Injectable({
    providedIn: "root"
})
export class ChatFullscreenService {

    config = environment;

    constructor(
        private _httpCliente: HttpClient
    ) {}

    validaParticipante(mensagemGuid: string, endereco: string): Observable<boolean> {
        return this._httpCliente.get<boolean>(`${this.config.chatApi}Mensagem/validate/participante?mensagemGuid=${mensagemGuid}&catalogo=${endereco}`).pipe(
            tap((response: boolean) => {
                response;
            },
            err => {
                console.error(`Ocorreu um erro durante a recuperação dos dados de Configuração do Chat:${JSON.stringify(err)}`);
            })
        );
    }

}